import clsx, { ClassValue } from "clsx";

import { Icon } from "../Icon";

type Props = Readonly<{
  className?: ClassValue;
  type?: "default" | "icon" | "smallIcon";
}>;

export const Divider = ({ className, type = "default" }: Props): JSX.Element => {
  const lineClassName = clsx("my-6 min-h-px h-px w-full bg-tertiary lg:my-8", className);

  if (type === "default") {
    return <div className={lineClassName} />;
  }

  return (
    <div className="flex w-full items-center justify-center gap-10">
      <div className={clsx(lineClassName, "flex-1")} />

      <Icon name="Divider" className={clsx("!h-fit", type === "icon" ? "!w-[5rem]" : "!w-12")} />

      <div className={clsx(lineClassName, "flex-1")} />
    </div>
  );
};
